import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import paymentMethodPropTypes from '../../../../prop-types/payment-method-prop-types';
import IconButton from '../../../IconButton';
import DeletePaymentMethodModal from '../../DeletePaymentMethodModal';

import styles from './DeleteButton.module.scss';

const DeleteButton = ({ paymentMethod, onRemove }) => {
  const [open, setOpen] = useState(false);

  const onOpen = useCallback(() => setOpen(true), []);
  const onClose = useCallback(() => setOpen(false), []);
  const onDelete = useCallback(() => {
    if (onRemove) {
      onRemove();
    }
    onClose();
  }, [onRemove, onClose]);
  return (
    <>
      <div className={styles.buttonWrapper}>
        <IconButton
          className={styles.button}
          icon="delete"
          iconProps={{ color: 'error' }}
          onClick={onOpen}
        />
      </div>

      <DeletePaymentMethodModal
        onCancel={onClose}
        open={open}
        paymentMethod={paymentMethod}
        onDelete={onDelete}
      />
    </>
  );
};

DeleteButton.propTypes = {
  onRemove: PropTypes.func,
  paymentMethod: paymentMethodPropTypes,
};

export default DeleteButton;
